export type ArtworkMedium = "canvas" | "ai" | "digital";

export function artworkPagePath(medium: ArtworkMedium, id: string): string {
  return `/art/${medium}/${encodeURIComponent(id)}`;
}

export function galleryPathForMedium(
  medium: ArtworkMedium,
  collection?: string,
): string {
  if (collection && collection !== "all") {
    return `/gallery?tab=${medium}&collection=${encodeURIComponent(collection)}`;
  }
  return `/gallery?tab=${medium}`;
}
